module.exports = __webpack_public_path__ + "static/img/spider-man.82d6ccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/faces/spider-man.jpg
// module id = 235
// module chunks = 1